import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../../baseUrl";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { lightBackground, white } from "../../Assets/Theme/ThemeColors";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import { userUnAuthorized } from "../../redux/actions/commonAction";

const MainLeadsForm = () => {
  let { id } = useParams();
  let param = id.split("_");

  let leadId = param[0];
  let accessType = param[param.length - 1];

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const state = useSelector((state) => state.user.data);

  const userBranch = state?.data?.user?.branch_code;
  console.log("userBranch converted", userBranch);

  const userType = state.data.user.user_type;
  console.log("state", userType);

  const [agents, setAgents] = useState([]);
  const [orderID, setOrderID] = useState("");
  const [date, setDate] = useState(
    `${
      new Date().getMonth() +
      1 +
      " / " +
      new Date().getDate() +
      " / " +
      new Date().getFullYear()
    }`
  );
  const [month, setMonth] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [brand, setBrand] = useState("");
  const [status, setStatus] = useState("");
  const [productType, setProductType] = useState("");
  const [wordCount, setWordCount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [remainingBalance, setRemainingBalance] = useState(0);
  const [merchant, setMerchant] = useState("");
  const [agent, setAgent] = useState("");
  const [isEcomLead, setIsEcomLead] = useState(false);

  const [branch, setBranch] = useState("");

  const dateD = new Date().getDate();
  const monthD = new Date().getMonth() + 1;
  var fullDate =
    new Date().getFullYear() +
    (String(monthD).length === 1 ? "-0" + monthD : "-" + monthD) +
    "-" +
    dateD;

  const [deliveryDate, setDeliveryDate] = useState(`${fullDate}`);
  console.log("fullDate", fullDate);

  const [comment, setComment] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);

  //notify states
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    getSpecific();
  }, []);

  const getSpecific = async () => {
    const response = await axios
      .post(
        `${url}${
          accessType === "CREATE"
            ? "/leads/getSpecific"
            : "/convertedLeads/getSpecific"
        }`,
        { _id: leadId },
        {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        }
      )
      .then((response) => {
        let data = response.data.data.data;
        console.log(data);
        userType === "admin" || leadId == "00000000"
          ? setIsDisable(false)
          : setIsDisable(true);

        if (accessType === "CREATE") {
          setName(data.client_name);
          setEmail(data.email);
          setPhone(data.phone_number);
          setBrand(data.brand);
          setAgent(data.agent_name ? data.agent_name._id : "");
          setComment(data.comment);
          setBranch(data.branch_code ? data.branch_code : "");
        } else {
          //reaOnly and update
          setName(data.customer_name);
          setEmail(data.email);
          setPhone(data.phone_number);
          setBrand(data.brand);
          setStatus(data.lead_status);
          setProductType(data.product_type);
          setWordCount(data.word_count);
          setAmount(data.amount);
          setOrderID(data.order_id);
          setRemainingBalance(data.remaining_balance);
          setMerchant(data.merchant);
          setDate(data.date.split("T")[0]);
          setDeliveryDate(data.delivery_date.split("T")[0]);
          setAgent(data.agent ? data.agent._id : "");
          setComment(data.comment);
          setBranch(data.branch_code ? data.branch_code : "");

          if (accessType === "update") {
            setIsReadOnly(false);
          } else {
            setIsReadOnly(true);
          }
        }
        setIsEcomLead(
          data.branch_code && data.branch_code === "ECOM" ? true : false
        );
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("unauthorized error");
          userUnAuthorized(dispatch);
        } else {
          console.log("network error");
          setIsLoaded(false);
          setIsOpen(true);
          setMessage(error.message);
          setSeverity("error");
        }
      });
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const getAllUsers = async () => {
    try {
      await axios
        .get(`${url}/auth/getAllUsers`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        })
        .then((response) => {
          console.log(
            "response",
            response.data.data.data.filter(
              (user) => user.user_type === "sales_agent"
            )
          );

          setAgents(
            response.data.data.data.filter(
              (user) =>
                user.user_type === "sales_agent" &&
                user.active === true &&
                (userBranch === "ALL-Br"
                  ? true
                  : user.branch_code === userBranch)
            )
          );
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            console.log("unauthorized error");
            userUnAuthorized(dispatch);
          } else {
            console.log("network error");
            setIsLoaded(false);
            setIsOpen(true);
            setMessage(error.message);
            setSeverity("error");
          }
        });
    } catch (error) {}
  };
  const submitForm = async () => {
    setIsLoaded(true);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    setMonth(monthNames[d.getMonth()]);
    const data =
      accessType === "CREATE"
        ? leadId == "00000000"
          ? {
              month: monthNames[d.getMonth()],
              customer_name: name,
              email: email,
              phone_number: phone,
              brand,
              lead_status: status,
              product_type: productType,
              word_count: Number(wordCount),
              amount: Number(amount),
              remaining_balance: Number(remainingBalance),
              merchant,
              agent,
              order_id: orderID,
              delivery_date: deliveryDate,
              comment,
              branch_code: branch,
            }
          : {
              month: monthNames[d.getMonth()],
              customer_name: name,
              email: email,
              phone_number: phone,
              brand,
              lead_status: status,
              product_type: productType,
              word_count: Number(wordCount),
              amount: Number(amount),
              remaining_balance: Number(remainingBalance),
              merchant,
              agent,
              order_id: orderID,
              delivery_date: deliveryDate,
              comment,
              parentId: leadId,
            }
        : {
            month: monthNames[d.getMonth()],
            customer_name: name,
            email: email,
            phone_number: phone,
            brand,
            lead_status: status,
            product_type: productType,
            word_count: Number(wordCount),
            amount: Number(amount),
            remaining_balance: Number(remainingBalance),
            merchant,
            agent,
            order_id: orderID,
            delivery_date: deliveryDate,
            comment,
            _id: leadId,
          };
    await axios
      .post(
        `${url}${
          accessType === "CREATE" ? "/convertedLeads" : "/convertedLeads/edit"
        }`,
        data,
        {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        }
      )
      .then(function (response) {
        if (response.data.data.success) {
          console.log(response.data.data.data);

          let id = response.data.data.data._id;

          navigate(`/convertedlead/${id}_readOnly`);

          console.log("true");
          setIsOpen(true);
          setMessage("Lead Converted Successfully!");
          setSeverity("success");
          setTimeout(() => {
            navigate("/convertedlead/list");
          }, 2000);
          // setIsLoaded(false);
        } else {
          setIsOpen(true);
          setMessage(response.data.data.message);
          setSeverity("error");
          console.log(response.data.message);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("unauthorized error");
          userUnAuthorized(dispatch);
        } else {
          console.log("network error");
          setIsLoaded(false);
          setIsOpen(true);
          setMessage(error.message);
          setSeverity("error");
        }
      });

    setTimeout(() => {
      setIsOpen(false);
      setIsLoaded(false);
    }, 2000);
  };

  return (
    <>
      <Container
        style={{
          maxWidth: "100%",
          padding: "0px",
          overflowY: "scroll",
          height: "90vh",
        }}
      >
        <Box sx={{ mt: 3 }}>
          <Paper sx={{ p: 3, mr: 2, ml: 2 }}>
            <Grid container sx={{ mt: 1, p: 3 }}>
              <Typography variant="h5" color="Primary">
                Convert Lead
              </Typography>
            </Grid>
            <Grid item className="Row" sx={{ p: 1 }}>
              <Grid item container md={9} xs={12}>
                <TextField
                  name="date"
                  label="Date"
                  margin="normal"
                  disabled={true}
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid container className="Row">
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="clientName"
                  label="Client Name"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  disabled={isReadOnly ? true : isDisable}
                />
              </Grid>
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="clientEmail"
                  label="Client Email"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isReadOnly ? true : isDisable}
                />
              </Grid>
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="clientPhone"
                  label="Client Phone No."
                  type="text"
                  margin="normal"
                  fullWidth
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  disabled={isReadOnly ? true : isDisable}
                />
              </Grid>
            </Grid>
            <Grid container className="Row">
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="brand"
                  label="Brand Name"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                  disabled={isReadOnly ? true : isDisable}
                />
              </Grid>
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="leadStatus"
                  label="Lead Status"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  disabled={isReadOnly}
                />
              </Grid>
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="productType"
                  label="Product / Service"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={productType}
                  onChange={(e) => setProductType(e.target.value)}
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container className="Row">
              {isEcomLead ? (
                ""
              ) : (
                <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                  <TextField
                    name="wordCount"
                    label="Word Count"
                    type="number"
                    margin="normal"
                    fullWidth
                    value={wordCount}
                    onChange={(e) => setWordCount(e.target.value)}
                    disabled={isReadOnly}
                  />
                </Grid>
              )}
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="amount"
                  label="Amount"
                  type="number"
                  margin="normal"
                  fullWidth
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  disabled={isReadOnly}
                />
              </Grid>
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="remainingBalance"
                  label="Remaining Balance"
                  type="number"
                  margin="normal"
                  fullWidth
                  value={remainingBalance}
                  onChange={(e) => setRemainingBalance(e.target.value)}
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container className="Row">
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="merchant"
                  label="Payment Merchant"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={merchant}
                  onChange={(e) => setMerchant(e.target.value)}
                  disabled={isReadOnly}
                />

              </Grid>
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <FormControl margin="normal" fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Agent
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={agent}
                    margin="normal"
                    label="Select Agent"
                    onChange={(e) => setAgent(e.target.value)}
                    disabled={isReadOnly ? true : isDisable}
                  >
                    {agents.length > 0 ? (
                      agents.map((user) => (
                        <MenuItem value={user._id}>{user.user_name}</MenuItem>
                      ))
                    ) : (
                      <MenuItem value={""}>none</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="orderId"
                  label="Order ID"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={orderID}
                  onChange={(e) => {
                    setOrderID(e.target.value);
                  }}
                  disabled={isReadOnly}
                />
              </Grid>

              <Grid item container md={4} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="deliveryDate"
                  label="Delivery Date"
                  type="date"
                  margin="normal"
                  fullWidth
                  value={deliveryDate}
                  onChange={(e) => {
                    setDeliveryDate(e.target.value);

                    console.log(e.target.value);
                  }}
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container className="Row">
              <Grid item container md={12} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="comment"
                  label={isEcomLead ? "Meeting Minutes":"Comment"}
                  multiline
                  rows={4}
                  type="text"
                  margin="normal"
                  fullWidth
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className="Row"
              sx={{ mt: 2 }}
              style={{
                gap: "10px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Grid item container md={1} xs={1}>
                <Button
                  type="clear"
                  style={{
                    border: `1px solid ${lightBackground}`,
                    color: `${lightBackground}`,
                    background: `${white}`,
                  }}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  onClick={() => {
                    navigate("/convertedlead/list");
                  }}
                >
                  back
                </Button>
              </Grid>
              {accessType !== "readOnly" ? (
                <Grid item container md={1} xs={1}>
                  <Button
                    onClick={submitForm}
                    variant="contained"
                    style={{
                      background: `${lightBackground}`,
                      color: `${white}`,
                    }}
                    margin="normal"
                    fullWidth
                    disabled={isLoaded}
                  >
                    {isLoaded ? (
                      <span>
                        {" "}
                        <CircularProgress
                          style={{
                            color: `${white}`,
                            height: "20px",
                            width: "20px",
                          }}
                        />
                      </span>
                    ) : accessType === "CREATE" ? (
                      "save"
                    ) : (
                      "UPDATE"
                    )}
                  </Button>
                </Grid>
              ) : (
                []
              )}
            </Grid>
          </Paper>
        </Box>
      </Container>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default MainLeadsForm;
